export enum StepEnum {
    General = 0,
    PageVisibility = 1,
    Membership = 2
}
